export default "__VITE_ASSET__B3gM86KN__"